import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="relative min-h-screen flex justify-center items-start bg-lightblue overflow-hidden px-2 md:px-0">
      <div className="random-balls-bg" id="randomBallsBg"></div>
      <div className="relative z-10 w-full max-w-[90vw] mx-auto flex justify-center items-start py-12">
        <div className="w-full max-w-3xl bg-white bg-opacity-90 rounded-3xl shadow-2xl p-10 border border-gray-200">
          <h1 className="text-4xl font-extrabold text-primary mb-4 text-center">Privacy Policy</h1>
          <h2 className="text-xl font-semibold text-center mb-6">Universal Science Academy</h2>
          <p className="mt-4 text-gray-700 text-center">
            Universal Science Academy is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you interact with our tuition center, website, and services.
          </p>
          <div className="mt-8">
            <h3 className="text-lg font-semibold mt-6">1. Information We Collect</h3>
            <ul className="list-disc pl-6 text-gray-700">
              <li><strong>Personal Details:</strong> Name, email address, phone number, and address.</li>
              <li><strong>Academic Information:</strong> Student’s grade level, school details, and subjects of interest.</li>
              <li><strong>Payment Information:</strong> If applicable, we collect billing details for tuition fees.</li>
              <li><strong>Technical Data:</strong> IP address, browser type, and interactions with our website.</li>
            </ul>
            <h3 className="text-lg font-semibold mt-6">2. How We Use Your Information</h3>
            <ul className="list-disc pl-6 text-gray-700">
              <li>To enroll students and manage class schedules.</li>
              <li>To communicate updates, schedules, and announcements.</li>
              <li>To process payments and generate invoices.</li>
              <li>To improve our services and website functionality.</li>
              <li>To ensure a safe and secure learning environment.</li>
            </ul>
            <h3 className="text-lg font-semibold mt-6">3. Sharing of Information</h3>
            <p className="text-gray-700">We do not sell or rent personal information to third parties. However, we may share information:</p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>With instructors for class management.</li>
              <li>With payment processors for fee transactions.</li>
              <li>As required by law or to protect our rights and safety.</li>
            </ul>
            <h3 className="text-lg font-semibold mt-6">4. Data Security</h3>
            <p className="text-gray-700">We implement strict security measures to protect personal information from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure.</p>
            <h3 className="text-lg font-semibold mt-6">5. Your Rights and Choices</h3>
            <ul className="list-disc pl-6 text-gray-700">
              <li>You can request access to your personal information.</li>
              <li>You can ask us to correct or delete your data.</li>
              <li>You can opt out of promotional communications at any time.</li>
            </ul>
            <p className="text-gray-700 mt-2">To exercise these rights, contact us at <a href="mailto:universalscienceacademyjaffna@gmail.com" className="underline hover:text-pink-400">universalscienceacademyjaffna@gmail.com</a>.</p>
            <h3 className="text-lg font-semibold mt-6">6. Changes to This Privacy Policy</h3>
            <p className="text-gray-700">We may update this policy from time to time. Any changes will be posted on our website with the updated effective date.</p>
            <h3 className="text-lg font-semibold mt-6">7. Contact Us</h3>
            <p className="text-gray-700">If you have any questions regarding this Privacy Policy, please contact us at:</p>
            <div className="mt-2 text-gray-700">
              <p><strong>Universal Science Academy</strong></p>
              <p>K.K.S Road Chunnakam</p>
              <p>Email: <a href="mailto:universalscienceacademyjaffna@gmail.com" className="underline hover:text-pink-400">universalscienceacademyjaffna@gmail.com</a></p>
              <p>Phone: <a href="tel:0779966888" className="underline hover:text-pink-400">0779966888</a></p>
            </div>
            <p className="mt-6 text-center text-gray-600">By using our services, you agree to the terms of this Privacy Policy.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

